module.exports = __webpack_public_path__ + "img/file-check.1d0bbfb1.svg";